<template>
    <div class="text-center py-4"
        style="background: url('/assets/header_bg.png'); background-repeat: no-repeat; background-size: 100% 100%;">
        <h1 style="color:#FFCD05; margin:0; padding:0; line-height:1em;">
            {{ title }}
        </h1>
        <h2
            style="color:#FFF; text-transform:uppercase; font-size:45px; font-weight:bolder; margin:0; padding:0; line-height:1em;">
            {{ sub_title }}
        </h2>
        <p style="color:#FFF; text-transform:uppercase; font-size:13px; margin:0; padding:0; margin-bottom:20px;">
            {{ desc }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'QuickCard',
    props: {
        title: {
            type: String,
        },
        sub_title: {
            type: String,
        },
        desc: {
            type: String,
        }
    }
}
</script>

<style scoped></style>